type Success<T> = [null, T];
type Failure<E> = [E, null];
export type Result<T, E = Error> = Success<T> | Failure<E>;

export function tryCatch<T, E = Error>(promise: Promise<T>): Promise<Result<T, E>>;

export function tryCatch<T, E = Error>(fn: () => T): Result<T, E>;

export function tryCatch<T, E = Error>(input: Promise<T> | (() => T)): Promise<Result<T, E>> | Result<T, E> {
    if (typeof input === 'function') {
        try {
            return [null, input()];
        } catch (error) {
            return [error as E, null];
        }
    }

    return input.then(data => [null, data] as Success<T>).catch(error => [error as E, null]);
}
